import { render, staticRenderFns } from "./XLSXView.vue?vue&type=template&id=4ba1b9b4"
import script from "./XLSXView.vue?vue&type=script&lang=js"
export * from "./XLSXView.vue?vue&type=script&lang=js"
import style0 from "./XLSXView.vue?vue&type=style&index=0&id=4ba1b9b4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports